<template>
  <div id="app" class="flex-col con-app">
    <!--缓存想要缓存的页面，实现后退不刷新-->
    <!--加上v-if的判断，可以自定义想要缓存的组件，自定义在router里面-->
    <transition :name="transitionName" mode="out-in">
      <keep-alive :include="keepAlives">
        <router-view class="f1" />
      </keep-alive>
    </transition>
    <div class="iphoneX" />
    <!--底部导航的占位高度 不能屏蔽-->
    <div v-show="!isShowTabBar" class="placeholder-bar-nav-app" />
    <!-- <AppNavBar v-show="showAppBar" class="bar-nav-app iphoneX" /> -->
  </div>
</template>

<script>
// import AppNavBar from 'components/AppNavBar';
import { mapActions, mapGetters } from "vuex"; //引入方法
import "./event";
// import { keepAlives } from "./router";
export default {
  name: "App",
  // components: { AppNavBar },
  computed: {
    ...mapGetters("common", ["isShowTabBar", "appTransitionName"])
  },
  created() {
    this.init();
  },
  data: function() {
    return {
      transitionName: "slide-left",
      keepAlives:[]
    };
  },
  mounted() {},
  methods: {
    ...mapActions("init", ["init"])
  },

  watch: {
    //使用watch 监听$router的变化
    $route(to, from) {
      const isBack = to.meta.deepth < from.meta.deepth
      this.transitionName = `slide-${{true:'right',false:'left'}[isBack]}`
      // 如果要to(进入)的页面是需要keepAlive缓存的，把name push进keepAlives中
      if (to.meta.keepAlive && !this.keepAlives.includes(to.name) ) {
         this.keepAlives.push(to.name);
      }
      // 如果 要 form(离开) 的页面是 keepAlive缓存的，
      // 再根据 deepth 来判断是前进还是返回
      // 如果是返回删除之前的keepAlive缓存：
      if (from.meta.keepAlive && isBack) {
         this.keepAlives = this.keepAlives.filter(name=>name!==from.name)
      }
    }
  }
};
</script>

<style lang="less" scoped>
.con-app {
  min-height: 100vh;
  overflow: hidden;
  .bar-nav-app {
    width: 100%;
    bottom: 0;
    z-index: 1000;
    position: fixed;
  }
  .placeholder-bar-nav-app {
    height: 96px;
  }
}
</style>
